module.exports = __webpack_public_path__ + "static/media/20.9e1091f2.jpg";